import { PrimaryButton } from 'components/button';
import styled from 'styled-components';
import {
    colorLightBlue,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const GradientBg = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    overflow: hidden;

    background: linear-gradient(
        132.66deg,
        ${colorLightBlue} 3.77%,
        #fed9f9 100%
    );
`;

export const GreenSphere = styled.div`
    background: #4dff88;
    box-shadow: 0px 0px 300px 300px #4dff88;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    position: absolute;
    left: 0px;
    top: 425px;
    z-index: 1;

    @media (${mediaXs}) {
        left: 15%;
        transform: translateX(-50%);
        box-shadow: 0px 0px 150px 150px #4dff88;
        top: 300px;
        opacity: 0.6;
    }
`;

export const VioletSphere = styled.div`
    background: #ef9dff;
    box-shadow: 0px 0px 250px 250px #ef9dff;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 450px;
    z-index: 1;

    @media (${mediaXs}) {
        right: 15%;
        opacity: 0.6;
        transform: translateX(50%);
        box-shadow: 0px 0px 150px 150px #ef9dff;
        top: 320px;
    }
`;

export const Title = styled.h4`
    font-size: 72px;
    font-weight: 400;
    line-height: 72px;
    color: ${({ theme }) => theme.palette.black};
    position: relative;
    z-index: 5;

    @media (${mediaXs}) {
        font-size: 32px;
        line-height: 36px;
    }
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.palette.black};
    font-size: 24px;
    font-weight: 300;
    line-height: 27px;
    max-width: 840px;
    position: relative;
    z-index: 5;

    @media (${mediaMd}) {
        margin-bottom: 8px;
    }

    @media (${mediaXs}) {
        font-size: 18px;
        line-height: 21px;
    }
`;

export const ButtonBlack = styled(PrimaryButton)`
    border-radius: 8px;
    background: ${({ theme }) => theme.palette.black};
    font-weight: 500;

    &:hover:not(:disabled) {
        background: ${({ theme }) => theme.palette.black};
    }

    @media (max-width: 500px) {
        width: 100%;
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 34px;
    position: relative;

    @media (${mediaMd}) {
        gap: 24px;
    }

    @media (${mediaSm}) {
        gap: 16px;
    }
`;

export const Duck = styled.img`
    width: 220px;
    height: 220px;
    position: absolute;
    right: -50px;
    bottom: -130px;
    z-index: 3;

    @media (${mediaMd}) {
        width: 164px;
        height: 164px;
        right: 140px;
    }

    @media (${mediaSm}) {
        width: 98px;
        height: 98px;

        right: 75px;
        bottom: -140px;
    }
`;

export const KBalloon = styled.img`
    width: 247px;
    height: 247px;
    position: absolute;
    right: -220px;
    bottom: -50px;
    z-index: 2;

    @media (${mediaMd}) {
        width: 192px;
        height: 192px;
        right: 10px;
        bottom: -90px;
    }

    @media (${mediaSm}) {
        width: 120px;
        height: 120px;

        right: -10px;
        bottom: -130px;
    }
`;

export const Balloon = styled.img`
    width: 150px;
    height: 150px;
    position: absolute;
    right: -60px;
    bottom: 20px;
    z-index: 1;

    @media (${mediaMd}) {
        width: 100px;
        height: 100px;
        bottom: -20px;
        right: 125px;
    }

    @media (${mediaSm}) {
        width: 65px;
        height: 65px;

        right: 65px;
        bottom: -80px;
    }
`;
